exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (max-width: 992px){\n.second-header-box>div[data-v-7f525e00]{\n        border-bottom: 1px solid #dde0e5;\n}\n.second-header-box>div>div[data-v-7f525e00],.second-header-box>div>h1[data-v-7f525e00],.second-header-box>div>h6[data-v-7f525e00]{\n        text-align: center;\n}\n}\n", ""]);

// exports
